import type { SeriesResponseDto } from '@/api/generated/api'
import { CardGrid } from './CardGrid'
import { SeriesCard } from './SeriesCard'

interface SeriesSectionProps {
  series?: SeriesResponseDto[]
}

export function SeriesSection({ series = [] }: SeriesSectionProps) {
  return (
    <CardGrid
      items={series}
      emptyState={{
        icon: (
          <svg
            className="h-8 w-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
            />
          </svg>
        ),
        emoji: '📚',
        title: 'No series yet',
        description: 'Tap + to create a series',
      }}
      renderCard={seriesItem => <SeriesCard series={seriesItem} />}
      getItemLink={seriesItem => `/series/${seriesItem.id}`}
      getItemKey={seriesItem => seriesItem.id}
    />
  )
}
